import React, { Component } from 'react';
import { Dialog, DialogContent, Checkbox, FormGroup, FormControlLabel } from "@material-ui/core"

import VMButton from '@/Common/VMButton';
import i18n from '@/i18n';

import { fabric } from 'fabric';
import { MD5 } from 'crypto-js'

import './ImageCropDialog.scss';

const CANVAS_WIDTH = 600;
const CANVAS_HEIGHT = 400;
const STROKE_WIDTH = 6;

class ImageCropDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            aspect: props.aspect,
            isFixAspect: true,
            iWidth: null,
            iHeight: null
        }
    }

    src;
    orgScale;

    canvas;
    imageObj;
    orgImg;
    maskRect;
    mask;
    maskState;
    panel;

    isClicked = false;

    componentWillUnmount = () => {
        this.DisposeCanvas();
    }


    componentWillReceiveProps = (nextProps) => {
        this.setState({ aspect: (this.state.isFixAspect ? nextProps.aspect : NaN) });
        this.closing = false;
    }

    componentDidUpdate = () => {
        if (!this.canvas && this.state.iWidth) {
            this.canvas = new fabric.Canvas('c', { backgroundColor: "transparent", selection: false});
            const image = document.getElementById('v');

            const { iHeight, iWidth } = this.state

            this.imageObj = new fabric.Image(image, {
                width: iWidth,
                height: iHeight,
                objectCaching: false,
                originX: 'center',
                originY: 'center',
                selectable: false,
                hoverCursor: 'default',
            });

            let sizeX = this.canvas.width / this.imageObj.width;
            let sizeY = this.canvas.height / this.imageObj.height;

            if (sizeX < sizeY) {
                sizeY = sizeX;
            }
            else {
                sizeX = sizeY;
            }

            this.imageObj.scaleX = sizeX 
            this.imageObj.scaleY = sizeY
          

            this.canvas.centerObject(this.imageObj);

            this.canvas.add(this.imageObj);

            let fw, fh;
            const isNoFixAspect = this.props.cropMetaData && this.props.cropMetaData.crop && this.props.cropMetaData.crop.isNoFixAspect
    
            if (this.props.aspect >= this.imageObj.width / this.imageObj.height) {
                fw = this.imageObj.width;
                fh = fw * 1 / this.props.aspect;
            }
            else {
                fh = this.imageObj.height;
                fw = fh * this.props.aspect;
            }

            const panel = new fabric.Rect({
                left: 0,
                top: 0,
                width: this.canvas.width,
                height: this.canvas.height,
                backgroundColor: '#000',
                opacity: 0.8,
                selectable: false,
                hoverCursor: 'default',
                type: "Panel"
            });

            const center = panel.getCenterPoint();
            let isCropped = false;
            this.orgScale = {
                x: this.imageObj.scaleX,
                y: this.imageObj.scaleY
            }
            let cropedMetaData = null;
            let width = !isNoFixAspect ? fw : this.imageObj.width;
            let height = !isNoFixAspect ? fh : this.imageObj.height;
            if (this.props.cropMetaData && this.props.cropMetaData.crop) {
                isCropped = true;
                cropedMetaData = this.calcMaskRectPostion({ ...this.props.cropMetaData.crop, width, height });
            }
            const left = cropedMetaData ? cropedMetaData.left : center.x;
            const top = cropedMetaData ? cropedMetaData.top : center.y;
            const scaleX = cropedMetaData ? cropedMetaData.scale : this.imageObj.scaleX;
            const scaleY = cropedMetaData ? cropedMetaData.scale : this.imageObj.scaleY;

            this.maskState = {
                origin:{
                    left: center.x,
                    top: center.y,
                    width: fw,
                    height: fh,
                    scaleX: this.orgScale.x,
                    scaleY: this.orgScale.y,
                }
            }
            this.mask = new fabric.Rect({
                left,
                top,
                width,
                height,
                originX: 'center',
                originY: 'center',
                scaleX,
                scaleY,
                absolutePositioned: true,
            });
            this.mask.inverted = true;

            panel.clipPath = this.mask;

            this.maskRect = new fabric.Rect({
                left,
                top,
                width,
                height,
                originX: 'center',
                originY: 'center',
                scaleX,
                scaleY,
                fill: 'rgba(0,0,0,0)',
                strokeWidth: STROKE_WIDTH,
                lockRotation: true,
                lockUniScaling: true,
                stroke: '#1fbdcb',
                lockScalingFlip: true,
                hasRotatingPoint: false,
                cornerSize: 20,
                cornerStyle: 'circle',
                cornerColor: '#1fbdcb',
                cornerStrokeColor: '#1fbdcb',
                transparentCorners: false,
            });

            this.maskRect.on('moving', (e) => {
                const obj = e.target;
                this.setInnerRect(obj);

                this.mask.left = e.target.left;
                this.mask.top = e.target.top;
                this.mask.setCoords();
                panel.clipPath = this.mask;
                panel.dirty = true;
            });

            this.maskRect.on('scaling', (e) => {
                const obj = e.target;
                if (!this.getIsImgRotate(this.imageObj.angle)) {
                    const { scaleX, scaleY } = this.maskState.origin
                    if (obj.scaleX > scaleX || obj.scaleY > scaleY) {
                        obj.scaleX = scaleX;
                        obj.scaleY = scaleY;
                        obj.setCoords();
                    }
                } else {
                    const { scaleX, scaleY } = this.maskState.rotate
                    if (obj.scaleX > scaleX || obj.scaleY > scaleY) {
                        obj.scaleX = scaleX;
                        obj.scaleY = scaleY;
                        obj.setCoords();
                    }
                }
                this.setInnerRect(obj);

                this.mask.left = e.target.left;
                this.mask.top = e.target.top;
                this.mask.scaleX = obj.scaleX;
                this.mask.scaleY = obj.scaleY;
                this.mask.setCoords();
                panel.clipPath = this.mask;
                panel.dirty = true;

            });
            if (!isCropped) {
                this.canvas.centerObject(this.mask);
                this.canvas.centerObject(this.maskRect)
            }
            // this.canvas.add(this.mask)
            this.setState({ isFixAspect: !isNoFixAspect })
            this.canvas.add(panel);
            this.canvas.add(this.maskRect);
            this.canvas.setActiveObject(this.maskRect);
        }

    }

    DisposeCanvas = () => {
        if (this.canvas) {
            this.canvas.clear();
            this.canvas = null;
        }
    }

    setInnerRect = (obj) => {
        let heightLimit = this.imageObj.getBoundingRect().height;
        let widthLimit = this.imageObj.getBoundingRect().width;
        let beginX = this.imageObj.getBoundingRect().left;
        let beginY = this.imageObj.getBoundingRect().top;
        obj.setCoords();
        if (obj.getBoundingRect().top < beginY || obj.getBoundingRect().left < beginX) {
            obj.top = Math.max(obj.top, beginY + obj.top - obj.getBoundingRect().top);
            obj.left = Math.max(obj.left, beginX + obj.left - obj.getBoundingRect().left);
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > beginY + heightLimit ||
            obj.getBoundingRect().left + obj.getBoundingRect().width > beginX + widthLimit) {
            obj.top = Math.min(obj.top, heightLimit - obj.getBoundingRect().height + beginY + obj.top - obj.getBoundingRect().top);
            obj.left = Math.min(obj.left, widthLimit - obj.getBoundingRect().width + beginX + obj.left - obj.getBoundingRect().left);
        }
    }

    calcMaskRectPostion = ({ x, y, zoom, width, height }) => {
        const scale = this.orgScale.x / zoom;
        const center = {
            x: this.canvas.width * 0.5,
            y: this.canvas.height * 0.5
        }
        const left = center.x - x * (width * scale);
        const top = center.y - y * (height * scale);

        return {
            left,
            top,
            scale
        }
    }

    setMaskObject = ({ width, height, scaleX, scaleY, left, top }) => {
        this.maskRect.set({
            width,
            height,
            scaleX,
            scaleY,
            left,
            top
        })
        this.mask.set({
            width,
            height,
            scaleX,
            scaleY,
            left,
            top
        })
        this.canvas.centerObject(this.maskRect)
        this.canvas.centerObject(this.mask)
        this.canvas.setActiveObject(this.maskRect);
        this.mask.setCoords();
        this.maskRect.setCoords();
        this.canvas.requestRenderAll();
    }

    fixAspect = (isFix) => {
        this.setState({ aspect: (isFix ? this.props.aspect : NaN), isFixAspect: isFix }, () => {
            if (this.state.isFixAspect) {
                let stateKey = !this.getIsImgRotate(this.imageObj.angle) ? "origin" : "rotate";
                const { width, height, scaleX, scaleY, left, top } = this.maskState[stateKey];
            
                this.setMaskObject({ width, height, scaleX, scaleY, left, top })
                return;
            }
            const { width: originWidth, height: originHeight,  scaleX, scaleY, left, top } = this.imageObj;
            let width = originWidth;
            let height = originHeight;
            if (this.getIsImgRotate(this.imageObj.angle)) {
                width = originHeight;
                height = originWidth;
            }
            this.setMaskObject({ width, height, scaleX, scaleY, left, top })
        })
    }


    componentDidMount = () => {
        if (this.props.src) {
            this.setState({ src: this.props.src });
        }
    }


    generateFilename = src => {
        let val = ''
        if (src.length <= 10000) val = src
        else {
            for (let i = 0; i < src.length; i += Math.floor(src.length / 100)) {
                val += src.slice(i, i + 100)
            }
        }
        // MD5 => 같은 파일은 같은 해시 결과를 뱉어냄.
        // 단, 5분이 지날때마다 같은 파일 입력시에는 별도 파일로 인식하도록 로직 작성 (업로드 오류현상에 대한 추가 로직)
        return `${MD5(val)}_${Math.floor(Date.now() / (1000 * 60 * 5))}`
    }

   endImageCrop() {
        
       if (!this.maskRect || this.isClicked) return;
       this.isClicked = true;
       
       const { mimetype = "image/png" } = this.props;
       const extname = mimetype.split('/')[1]


       const image = document.getElementById("v");
       const originImage = new fabric.Image(image, {
           angle: this.imageObj.angle,
           originX: 'center',
           originY: 'center',
           absolutePositioned: true,
       });

       const originSize = {
           width: originImage.width,
           height: originImage.height
       }
       if (this.getIsImgRotate(this.imageObj.angle)) {

           originSize.width = originImage.height;
           originSize.height = originImage.width;
       }

       this.orgImg = originImage.toDataURL({
           width: originSize.width,
           height: originSize.height,
           format: extname
       });

        const selectionRect = this.maskRect;
        let rect = new fabric.Rect({
            left: selectionRect.left,
            top: selectionRect.top,
            width: selectionRect.getScaledWidth() - STROKE_WIDTH,
            height: selectionRect.getScaledHeight() - STROKE_WIDTH,
            angle: selectionRect.angle,
            originX: 'center',
            originY: 'center',
            absolutePositioned: true,
            backgroundColor: "transparent"
        });
        this.imageObj.clipPath = rect;
      
        const cropped = new Image();

        const self = this;

        this.canvas.remove(selectionRect);


   

        const point = rect.getPointByOrigin("left", "top")
        cropped.src = this.canvas.toDataURL({
            left: point.x,
            top: point.y,
            width: rect.width,
            height: rect.height,
            format:extname
        });
    
        cropped.onload = function () {
            self.canvas.clear();
            const image = new fabric.Image(cropped, {
                left: rect.left,
                top: rect.top
            });
            image.setCoords();
            self.canvas.add(image);
            self.canvas.renderAll();
            self.onCropComplete(cropped.src);
        };
    }

    onCropComplete = async (cropThumbnail) => {
        const center = {
            x: this.canvas.width * 0.5,
            y: this.canvas.height * 0.5
        }

        const crop = {
            x: (center.x - this.maskRect.left) / (this.maskRect.width * this.maskRect.scaleX),
            y: (center.y - this.maskRect.top) / (this.maskRect.height * this.maskRect.scaleY),
            zoom: this.orgScale.x / this.maskRect.scaleX,
            isNoFixAspect: !this.state.isFixAspect
        }
     

        // if (this.getIsImgRotate(this.imageObj.angle)) {
        //     // (이미지 스케일 X * (이미지 세로 길이 / 이미지 가로 길이)) / this.maskRect.scaleX
        //     crop.zoom = (this.imageObj.scaleX * (this.imageObj.height / this.imageObj.width)) / this.maskRect.scaleX
        // }

        const { cropType, src, cropComplete, closeDialog } = this.props
        let file = null;

        const filename = this.generateFilename(src);
        file = this.dataURItoFile(this.orgImg, filename);
        const thumbnailImage = this.dataURItoFile(cropThumbnail, `${filename}_thumb`)
        cropComplete(file, { crop, source: cropType }, thumbnailImage);
        closeDialog();
    }
 
    dataURItoFile = (dataURI, filename) => {
        let arr = dataURI.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }

        const extname = mime.split('/')[1]
        return new File([u8arr], `${filename}.${extname}`, { type: mime })
    }

    getIsImgRotate = (angle) => Math.abs(angle) / 90 % 2 === 1;

    rotateTo = (degree) => {

        const changeAngle = this.imageObj.angle + degree;
        const isRotate = this.getIsImgRotate(changeAngle);
        
        this.imageObj.rotate(changeAngle);


        if (!this.state.isFixAspect) this.fixAspect(true);

        if (isRotate) {
            let fw, fh;
            const width = this.imageObj.height;
            const height = this.imageObj.width;


            if (this.props.aspect >= width / height) {
                fw = width;
                fh = fw * 1 / this.props.aspect;
            }
            else {
                fh = height;
                fw = fh * this.props.aspect;
            }
            let sizeX = this.canvas.width / width;
            let sizeY = this.canvas.height / height;

            if (sizeX < sizeY) {
                sizeY = sizeX;
            }
            else {
                sizeX = sizeY;
            }
            const { left, top } = this.maskRect;
            this.maskState.rotate = { width: fw, height: fh, scaleX: sizeX, scaleY: sizeY, left, top };
            this.setMaskObject({ width: fw, height: fh, scaleX: sizeX, scaleY: sizeY, left, top })
            this.imageObj.set({ scaleX: sizeX, scaleY: sizeY });
            this.orgScale = { x: sizeX, y: sizeY }
        } else {
            const { width, height, scaleX, scaleY, left, top } = this.maskState.origin;
            this.orgScale = { x: scaleX, y: scaleY }
            this.imageObj.set({ scaleX, scaleY })
            this.setMaskObject({ width, height, scaleX, scaleY, left, top })
            
        }

        this.imageObj.setCoords();

        this.setInnerRect(this.maskRect);

        this.maskRect.setCoords();
        this.mask.left = this.maskRect.left;
        this.mask.top = this.maskRect.top;
        this.mask.scaleX = this.maskRect.scaleX;
        this.mask.scaleY = this.maskRect.scaleY;
        this.mask.setCoords();
        this.canvas.requestRenderAll();
    }

    renderCropper = () => {
        const { src, iWidth, iHeight } = this.state

        return (
            <div className='cropper-container' id="id123">
                <canvas id='c' width={CANVAS_WIDTH} height={CANVAS_HEIGHT}></canvas>
                <img
                    id="v"
                    src={src}
                    alt=''
                    width={iWidth}
                    height={iHeight}
                    style={{display:"none"}}
                    onLoad={(e) => {
                        if (!iWidth && !iHeight) {
                            this.setState({ iWidth: e.target.width, iHeight: e.target.height })
                        }
                    }}
                />
            </div>
        );

    }

    render() {
        const { open } = this.props
        
        return (
            <Dialog open={open} maxWidth="lg" classes={{paper:"image-crop-container"}} id="">
                {this.renderCropper()}
                <DialogContent >
                    <div className="ImageCropDialog-top-text">
                        <FormGroup>
                            <FormControlLabel
                                className="ImageCropDialog-form-control-label"
                                control={
                                    <Checkbox
                                        checked={this.state.isFixAspect}
                                        onChange={event => this.fixAspect(event.target.checked)}
                                    />}
                                label={i18n.t("ImageCropDialog.text1")}
                            />
                        </FormGroup>
                        <div className='dialog-text'>({i18n.t("ImageCropDialog.text2")})</div>
                    </div>
                    <div className='turnButton-wrapper'>
                        <div className="turnButton" onClick={() => { this.rotateTo(-90) }} style={{ float: 'left', marginRight: '8px' }}>
                            <img src="https://front.videomonster.com/images-7cuytg20/web/turnleft90arrow.png" alt="turnleft90arrow"></img>
                        </div>
                        <div className="turnButton" onClick={() => { this.rotateTo(90) }} style={{ float: 'left' }}>
                            <img src="https://front.videomonster.com/images-7cuytg20/web/turnright90arrow.png" alt="turnright90arrow"></img>
                        </div>
                    </div>
                </DialogContent>
                <div className="imgCropper-VMButton-container">
                    <VMButton color="primary-v2" onClick={() => this.endImageCrop()} width={'100px'} height={'30px'} style={{ float: 'left' }}>{i18n.t("ImageCropDialog.button.complete")}</VMButton>
                    <VMButton onClick={this.props.closeDialog} width={'100px'} height={'30px'} style={{ float: 'left' }} >{i18n.t("ImageCropDialog.button.close")}</VMButton>
                </div>

            </Dialog>
        );
    }
}

export default ImageCropDialog;